export const key_value_pair = (input: string): string => {
  const elements = input.split("=");
  if (
    elements.length == 2 &&
    elements[0].length > 0 &&
    elements[1].length > 0
  ) {
    return "";
  }
  return 'Format must be "key=value"';
};
